require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-nebuta-bs-jquery.json") })
        }
      }, "path---package-nebuta-bs-jquery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-nebuta-bs-jquery!./.cache/json/package-nebuta-bs-jquery.json
// module id = 878
// module chunks = 231608221292675